module.exports = __webpack_public_path__ + "static/media/JD.d5682eb4.png";